var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBroken03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.714 16.3639L10.3333 17.7781C8.42697 19.7308 5.33614 19.7308 3.42977 17.7781C1.52341 15.8255 1.52341 12.6597 3.42977 10.7071L4.81049 9.29286M19.1895 14.7071L20.5702 13.2929C22.4766 11.3402 22.4766 8.17441 20.5702 6.22179C18.6639 4.26917 15.573 4.26917 13.6667 6.22179L12.286 7.636M6.14214 14.9999C7.47657 13.6331 7.54117 13.5666 8.58247 12.5M15.4166 11.5C16.7511 10.1332 16.8157 10.0666 17.857 9.00006M20.7864 21L3.21276 3",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBroken03);
export default __webpack_public_path__ + "static/media/link-broken-03.9cbb9b07b8287d5da0738ecebbda9e77.svg";
export { ForwardRef as ReactComponent };